// dependencies
import { feature } from 'topojson-client'

// load in topojson data
import topojson from '../topojson/united_states.json'

// convert from topojson to geojson format
let geojson = feature(topojson, topojson.objects.gadm36_USA_1)
let states = geojson.features

// add state codes and state names
import STATES from '../constants/us_states.json'

for (let index = 0; index < states.length; index++) {
  let state = states[index]
  let key
  // state keys for these states are located at index 1
  let diff = ['Rhode Island', 'Pennsylvania', 'Massachusetts', 'Kentucky']
  if (diff.includes(state.properties.NAME_1)) {
    key = state.properties.VARNAME_1.split('|')[1]
  } else {
    key = state.properties.VARNAME_1.split('|')[0]
  }
  // special case for DC
  if (key === 'DC') {
    state.code = 'DC'
    state.name = 'District of Columbia'
    state.lat = 47.042418
    state.lng = -122.893077
  }
  if (STATES[key]) {
    state.code = STATES[key].code
    state.name = STATES[key].name
    state.lat = STATES[key].lat
    state.lng = STATES[key].lng
  }
}

// export
export { states, geojson }
